import apiClient from "./apiClient";

const PURCHASE = "/api/Purchase";
const STOCK = "/api/Stock";

const toDate = (d) => (d ? `${d}T00:00:00` : null);
const toNum = (v) => Number(v) || 0;

// Purchases
export const getPurchases = () => apiClient.get(`${PURCHASE}/all`);
export const getPurchase = (id) => apiClient.get(`${PURCHASE}/${id}`);
export const createPurchase = (data) =>
  apiClient.post(`${PURCHASE}/entry`, {
    supplierID: toNum(data.supplierID),
    supplierInvoiceNumber: data.invoiceNumber || "",
    supplierInvoiceDate: toDate(data.purchaseDate),
    purchaseDate: toDate(data.purchaseDate),
    paymentType: data.paymentMode || "Cash",
    bankID: toNum(data.bankId || data.bankID) || null,
    totalAmount: toNum(data.totalAmount),
    paidAmount: 0,
    balanceAmount: toNum(data.totalAmount),
    status: "Pending",
    remarks: data.remarks || "",
    details: (data.items || []).map((item) => {
      const qty = toNum(item.quantity);
      const rate = toNum(item.purchaseRate);
      const disc = toNum(item.discount);
      const amount = qty * rate * (1 - disc / 100);
      return { productID: toNum(item.productID), qty, rate, discount: disc, amount };
    }),
  });
export const updatePurchase = () => Promise.reject(new Error("Purchase update not supported by API"));
export const deletePurchase = () => Promise.reject(new Error("Delete not supported by API"));

// Purchase returns
export const getPurchaseReturns = () => apiClient.get(`${PURCHASE}/returns/all`);
export const getPurchaseReturn = (id) => apiClient.get(`${PURCHASE}/return/${id}`);
export const createPurchaseReturn = (data) =>
  apiClient.post(`${PURCHASE}/return`, {
    supplierID: toNum(data.supplierID),
    originalPurchaseID: data.originalPurchaseID || null,
    returnDate: toDate(data.returnDate),
    paymentType: data.paymentMode || "Cash",
    totalAmount: toNum(data.totalAmount),
    remarks: data.remarks || "",
    details: (data.items || []).map((item) => {
      const qty = toNum(item.quantity);
      const rate = toNum(item.purchaseRate);
      return { productID: toNum(item.productID), qty, rate, discount: 0, amount: qty * rate };
    }),
  });
export const updatePurchaseReturn = (id, data) => apiClient.put(`${PURCHASE}/return/${id}`, data);
export const deletePurchaseReturn = (id) => apiClient.delete(`${PURCHASE}/return/${id}`);

// Pending supplier bills (for payment allocation)
export const getPendingBills = (supplierId) =>
  apiClient.get(`${PURCHASE}/pending-bills/${supplierId}`);

// Opening stock — modal sends flat single-item; API expects header + details array
export const createOpeningStock = (data) => {
  const qty = toNum(data.quantity);
  const rate = toNum(data.purchaseRate);
  const amount = qty * rate;
  return apiClient.post(`${STOCK}/opening`, {
    entryDate: toDate(data.asOnDate),
    totalAmount: amount,
    remarks: data.remarks || "",
    details: [{ productID: toNum(data.productID), qty, rate, discount: 0, amount }],
  });
};
export const getOpeningStocks = () => apiClient.get(`${STOCK}/opening/all`);
export const getOpeningStock = (id) => apiClient.get(`${STOCK}/opening/${id}`);
export const updateOpeningStock = (id, data) => apiClient.put(`${STOCK}/opening/${id}`, data);
export const deleteOpeningStock = (id) => apiClient.delete(`${STOCK}/opening/${id}`);
